export default __webpack_public_path__ + "static/media/ring-1@3x.f738a6c7.jpg";